import React, { memo, useContext, useEffect } from "react";
import { Music } from "../../Util/Music/Music";
import { NoteData } from "../../Data/NoteData";
import { SVGAccidentalSplit } from "../../Util/Music/Accidentals/Accidentals";
import { ClassNames } from "../../Util/ClassNames";
import { TransformTranslate } from "../../Util/Transform/Transform";
import { motion } from "framer-motion";
import { Note } from "../../Data/HexMap/Note";
import DisplayConfig from "../../Data/HexMap/DisplayConfig";
import { DisplayContext } from "./DisplayContext";
import { HxPetalCluster } from "./HxPetalCluster";

export function getBaseClassNames(note:Note){
    const classNames:ClassNames = new ClassNames()
    switch(note.selectedState){
        case Note.SelectedState_Default: classNames.addClass('default'); break;
        case Note.SelectedState_Selected: classNames.addClass('selected'); break;
        case Note.SelectedState_Hilited: classNames.addClass('hilited'); break;
    }
    classNames.addClasses(note.classNames)
    return classNames
}
export const HxNote = memo(function HxNote (props:{note:Note, onNoteClick:Function, ctrl?:boolean, classNames?:string[]}){
    const displayConfig:DisplayConfig = useContext(DisplayContext);
    const baseClassNames:ClassNames = getBaseClassNames(props.note)
    const getCircleClassName = () => {
        const classNames:ClassNames = new ClassNames(['note-comp-circle'])
        classNames.addClasses(baseClassNames.classNames)
        return classNames.toString()
    }
    const getClassNames = () => {
        let classNames:ClassNames = new ClassNames(['note-comp'])
        if(props.classNames){classNames.addClasses(props.classNames)}
        classNames.addClasses(baseClassNames.classNames)
        classNames.addClass('note-index_' + props.note.params.noteIndex)
        const positionType:number = displayConfig.getPositionType(props.note)
        if(positionType === NoteData.PositionTypeSeven){
            classNames.addClass('seven')
        }
        else{
            const positionClass:string = (positionType === NoteData.PositionTypeOdd) ? 'odd' : 'even'
            classNames.addClass(positionClass)
        }
        classNames.addClass(Music.notes[props.note.params.tonic])
        classNames.addClasses(props.note.classNames)
        return classNames.toString()       
    }
    const onClick = (e:React.MouseEvent, ctrl?:boolean) => {
        props.onNoteClick(props.note, e)
    }
    const onCtrl = (e:React.MouseEvent) => {
        if(props.ctrl){
            e.preventDefault()
            props.onNoteClick(props.note, e, true)
        }
   
    }
    const getHalo = (note:Note) => {
        if(!note.halo){return null}
        return(
            <circle 
            className={'halo'} 
            r={displayConfig.getCircleRadius() * 1.2} 
            cy={0} cx={0}
            />
        )
    }
    if(!props.note.visible){return null}
    return(<g onContextMenu={(e)=>{onCtrl(e)}} className='note-comp-transformer' transform={TransformTranslate(props.note.params.x, props.note.params.y)}>
                    <g className={getClassNames()}>
                        {getHalo(props.note)}
                        <motion.circle
                            onClick={onClick} 
                            className={getCircleClassName()} 
                            r={displayConfig.getCircleRadius()} 
                            cy={0} cx={0}
                        />
                        <NoteLabel note={props.note} fontSize={displayConfig.getNoteFontSize()}/>
                    </g>
                    {false && <HxPetalCluster note={props.note}/>}
            </g>
            )
})

export function NoteKeyPetals(props:{noteData:NoteData}){
    if(props.noteData.keyPetals.length === 0) return null
    return null
}
export function NoteLabel(props:{note:Note, fontSize:number}){
    const baseClassNames:ClassNames = getBaseClassNames(props.note)
    const getLabel = function(){
        if(!props.note.defined){return ''}
        if(props.note.primaryLabel){
            return(
                <g className={'accidental-split'}>
                    <text dy={'.3em'} fontSize={props.fontSize} className={'accidental-split-base'}>
                        <tspan>{props.note.primaryLabel}</tspan>
                    </text>
                </g>
            )
        }
        return <SVGAccidentalSplit baseFontSize={props.fontSize} tonic={props.note.params.tonic}/>  
    }
    const getGroupClassNames = () => {
        const classNames:ClassNames = new ClassNames(['note-comp-name'])
        classNames.addClasses(baseClassNames.classNames)
        if(props.note.secondaryLabel !== null){classNames.addClass('with-secondary')}
        return classNames.toString()
    }
    const getGroupTransform = () => {
        if(!props.note.secondaryLabel){
            return undefined
        }
        return TransformTranslate(0,Math.floor(props.fontSize/-4))
    }
    const getLabelClassNames = () => {
        const classNames:ClassNames = new ClassNames(['primary-label'])
        classNames.addClasses(baseClassNames.classNames)
        return classNames.toString()
    }
    const getSecondaryLabel = function(){
        if(props.note.secondaryLabel === null || !props.note.defined){
            return null
        }
        const translateY:number = Math.floor(props.fontSize/0.9)
        return <g className='secondary-label' transform={TransformTranslate(0,translateY)}>
                    <text dy={'.3em'}>{props.note.secondaryLabel}</text>
                </g>
    }     
    if(!props.note.visible){return null}
    return  <g fontSize={props.fontSize} className={getGroupClassNames()} transform={getGroupTransform()}>
                <g className={getLabelClassNames()}>{getLabel()}</g>
                {getSecondaryLabel()}
            </g>
}

